import {WebCallService} from "@/utilities/system/services/WebCallService";
import {PathHelper} from "@/utilities/system/helpers/PathHelper";
import {ErrorLocationType, HttpType} from "@/utilities/system/enums/Enums";
import {Form} from "@/models/entities/forms/Form";
import ErrorHandler from "@/utilities/system/helpers/ErrorHandler";
import {ChangeOwnerRequest} from "@/models/api/requests";


export class FormService {
    private webCaller: WebCallService;
    private uriHelper: PathHelper;

    constructor(){
        this.webCaller = new WebCallService();
        this.uriHelper = new PathHelper();
    }

    public async getFormReports(errorLocationType:ErrorLocationType):Promise<Array<Form>|null> {
        const uri = this.uriHelper.forms.getFormReportsPath();

        const resp = await this.webCaller.HttpSend(HttpType.get, uri);
        if (resp === null || resp === undefined || (resp.statusCode !== undefined && resp.statusCode !== 0)) {
            ErrorHandler.handleError(resp, errorLocationType);
            return null;
        }

        return resp;
    }

    public async changeCurrentOwnerOfForm(formId:string, newOwnerId:string, errorLocationType:ErrorLocationType):Promise<any|null> { //TODO type!
        const uri = this.uriHelper.forms.getChangeFormOwnerPath(formId);

        const requestBody = new ChangeOwnerRequest(newOwnerId);

        const resp = await this.webCaller.HttpSend(HttpType.put, uri, requestBody);
        if (resp === null || resp === undefined || (resp.statusCode !== undefined && resp.statusCode !== 0)) {
            ErrorHandler.handleError(resp, errorLocationType);
            return null;
        }

        return resp;
    }

    public async ensurePdfCreationThenFetch(formId:string, errorLocationType:ErrorLocationType):Promise<ArrayBuffer|null>{
        const uri = this.uriHelper.forms.getEnsurePdfCreationThenFetchPath(formId)

        const resp = await this.webCaller.HttpSend(HttpType.post, uri);
        if (resp === null || resp === undefined || (resp.statusCode !== undefined && resp.statusCode !== 0)) {
            ErrorHandler.handleError(resp, errorLocationType);
            return null;
        }

        return resp;
    }

    public async generatePdf(formId:string, errorLocationType:ErrorLocationType):Promise<ArrayBuffer|null> {
        const uri = this.uriHelper.forms.getGeneratePdfPath(formId);
        
        const resp = await this.webCaller.HttpSend(HttpType.post, uri);
        if (resp === null || resp === undefined || (resp.statusCode !== undefined && resp.statusCode !== 0)) {
            ErrorHandler.handleError(resp, errorLocationType);
            return null;
        }

        return resp;
    }
}
